<div class="card mb-4">
    <div class="card-body">
      <h5 class="card-title text-center">Label Printing List</h5>
      <div class="col-lg-6 mt-4">
        <!-- Search Input -->
       
        <div class="row mt-3 mb-3 flex justify-content-between">
          <div class="col-md-6">
            <label>Search :</label>
            <input type="text" placeholder="Search by ticket number,Width " class="form-control mb-3"  [(ngModel)]="searchText" >
          </div>
        
          <div class="col-md-3">
            <label>From Date:</label>
            <input type="date" class="form-control" [(ngModel)]="fromDate">
          </div>
          <div class="col-md-3">
            <label>To Date:</label>
            <input type="date" class="form-control" [(ngModel)]="toDate">
          </div>
        </div>
    </div>
  </div>
    
      <!-- Table -->
      <div class="table-responsive" style="max-height: 900px; overflow-y: auto;">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>LabelPrint</th>
              <th>Ticket No</th>
              <th>Job Name</th>
              <th>Width</th>
              <th>Net Wet</th>
              <th>Date</th>
              <th>Batch</th>
              <th>Roll No</th>
            </tr>
          </thead>
          <tbody>
            <!-- Loop through each label in the labelPrintList -->
            <ng-container *ngFor="let label of filteredLabels">
              <!-- Loop through each row within the current label group -->
              <tr *ngFor="let row of label.row; let i = index">
                
                <!-- Display the 'Print Label' button once for each group of rows -->
                <td>
                  <!-- Render the button only for the first row in the group -->
                  <!-- <button *ngIf="i === 0" type="button" (click)="print(label._id)">
                    <i class="feather icon-printer"></i> Print Label
                  </button> -->

                  <button *ngIf="i === 0" type="button" (click)="print(label._id)">
                    <i class="feather icon-printer"></i> Print Label
                  </button>
                  
                </td>
                
                <!-- Display Ticket No only for the first row in the group -->
                <td>{{ i === 0 ? (label.ticketNo || 'N/A') : '' }}</td>
                <td>{{ i === 0 ? (label.jobName || 'N/A') : '' }}</td>
                <td>{{ i === 0 ? (label.width || 'N/A') : '' }}</td>
                <td>{{ i === 0 ? (label.batch || 'N/A') : '' }}</td>
                <td>{{ i === 0 ? (label.date | date:'dd-MM-yyyy') : '' }}</td>
  
                <!-- Display Job Name only for the first row in the group -->
                <!-- <td>{{ i === 0 ? (row.jobName || 'N/A') : '' }}</td> -->
  
                <!-- Always render these fields for every row -->
                <!-- <td>{{ row.width || 'N/A' }}</td> -->
                <td>{{ row.netwet || 'N/A' }}</td>
                <td>{{ row.rollNo || 'N/A' }}</td>
                <!-- <td>{{ row.batch || 'N/A' }}</td> -->
                <!-- <td>{{ row.date || 'N/A' }}</td> -->
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
   
</div>
